import type UnassignedShiftForm from 'modules/shift_management/lib/forms/UnassignedShiftForm'
import type UnassignedShift from 'modules/shift_management/store/internal/models/UnassignedShift'

interface FormDataReturnProps {
  counter: number | undefined
  start_at: string | undefined
  end_at: string | undefined
  color: string | undefined | null
  location_id: number | undefined | null
  work_area_id: number | undefined | null
  notes: string | undefined | null
  defaultShift_id: number | undefined | null
  default_shift_title: string | undefined | null
  extra_hours: boolean | null
  all_company: boolean | null
  teams_ids_visibilities: number | null | undefined
  locations_ids_visibilities: number | null | undefined
  staff_requirements: {
    staff_count: number
    job_catalog_roles_ids: number[]
  }[]
}

export const formData = (unassignedShift: UnassignedShift): FormDataReturnProps => {
  const teamIds = unassignedShift.teamsIdsVisibilities?.length
    ? unassignedShift.teamsIdsVisibilities[0]
    : null
  const locationIds = unassignedShift.locationsIdsVisibilities?.length
    ? unassignedShift.locationsIdsVisibilities[0]
    : null

  return {
    counter: unassignedShift.counter,
    start_at: unassignedShift.startTime,
    end_at: unassignedShift.endTime,
    color: unassignedShift.color,
    location_id: unassignedShift.locationId,
    work_area_id: unassignedShift.workAreaId,
    notes: unassignedShift.notes,
    defaultShift_id: unassignedShift.defaultShiftId,
    default_shift_title: unassignedShift.defaultShiftTitle,
    extra_hours: unassignedShift.extraHours,
    all_company: unassignedShift.allCompany,
    teams_ids_visibilities: teamIds,
    locations_ids_visibilities: locationIds,
    staff_requirements: [
      {
        staff_count: unassignedShift.counter,
        job_catalog_roles_ids: unassignedShift.jobCatalogRolesIds,
      },
    ],
  }
}

export const haveShiftDetailsChanged = (
  initialAttributes: FormDataReturnProps,
  unassignedShiftForm: UnassignedShiftForm
): boolean => {
  const counter = initialAttributes.counter?.toString()
  const startAt = initialAttributes.start_at
  const endAt = initialAttributes.end_at
  const locationId = initialAttributes.location_id ? initialAttributes.location_id.toString() : ''
  const workAreaId = initialAttributes.work_area_id ? initialAttributes.work_area_id.toString() : ''
  const notes = initialAttributes.notes ? initialAttributes.notes : ''
  const extraHours = !initialAttributes.extra_hours ? false : initialAttributes.extra_hours
  const extraHoursForm = !unassignedShiftForm.get('extra_hours').value
    ? false
    : unassignedShiftForm.get('extra_hours').value
  const allCompany = initialAttributes.all_company
  const teamsIdsVisibilities = initialAttributes.teams_ids_visibilities
    ? initialAttributes.teams_ids_visibilities.toString()
    : ''
  const locationsIdsVisibilities = initialAttributes.locations_ids_visibilities
    ? initialAttributes.locations_ids_visibilities.toString()
    : ''
  const jobCatalogRolesIds = initialAttributes.staff_requirements[0]?.job_catalog_roles_ids || []

  const formRoleIds = new Set<number>(
    unassignedShiftForm.get('staff_requirements').value[0].job_catalog_roles_ids
  )

  const currentRoleIds: Set<number> = new Set(jobCatalogRolesIds)
  const rolesChanged =
    formRoleIds.size !== currentRoleIds.size ||
    [...formRoleIds].some((id) => !currentRoleIds.has(id))

  return (
    counter !== unassignedShiftForm.get('staff_requirements').value[0].staff_count.toString() ||
    rolesChanged ||
    startAt !== unassignedShiftForm.get('start_at').value ||
    endAt !== unassignedShiftForm.get('end_at').value ||
    locationId !== unassignedShiftForm.get('location_id').value.toString() ||
    workAreaId !== unassignedShiftForm.get('work_area_id').value.toString() ||
    notes !== unassignedShiftForm.get('notes').value ||
    extraHours !== extraHoursForm ||
    allCompany !== unassignedShiftForm.get('all_company').value ||
    teamsIdsVisibilities !== unassignedShiftForm.get('teams_ids_visibilities').value.toString() ||
    locationsIdsVisibilities !==
      unassignedShiftForm.get('locations_ids_visibilities').value.toString()
  )
}
